import PubSub from 'pubsub-js';

// Lazyload
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import SideMenu from '../lib/SideMenu';

// Require vendor packages that are implicitly included, e.g. via jQuery plugins.
require('slick-carousel');

// General window events. Events fired via PubSub.
require('../lib/window-scroll-events');
require('../lib/keyboard-events');

import '../lib/announcement-bar';

window.gm = null;

function accordions() {
  $('.accordion-row-header').on('click', function () {
    let $this = $(this);

    $this.parent().toggleClass('active');
    $this.next('.accordion-row-body').stop().slideToggle(200);
  });

  $(window).on('load', function () {
    let hash = window.location.hash;

    if (hash.length > 0 && $(hash).length > 0) {
      $(hash).addClass('active').find('.accordion-row-body').slideDown(200);
    }
  });
}

function initSliders() {

  $('.slick-slider').each(function () {
    let $this = $(this);
    // These args can be overridden by passing a `data-slick` option in the
    // .slick-slider element in a JSON format.
    let args = {
      infinite: true,
      adaptiveHeight: false,
      arrows: true,
      swipeToSlide: true,
      autoplay: false,
      autoplaySpeed: 7000,
      dots: true,
    };

    $this.slick(args);

    $this.on('swipe', event => {
      event.preventDefault();
    });
  });

}

function toggles() {
  $('[data-toggle]').on('click', function (e) {
    e.preventDefault();

    let $this = $(this);
    let $target = $( $this.data('target') );

    $target.slideToggle(200);

    setTimeout(function() {
      let cbType = $target.is(':visible') ? 'toggle-open-cb' : 'toggle-close-cb';

      if (window[ $this.data(cbType) ]) {
        window[ $this.data(cbType) ]();
      }
    }, 250);
  });
}

function anchorLinks()
{
  $(document).on('click', '[href^="#"]', function(e) {
    let $this = $(this);
    let $target = $($this.attr('href'));

    if ($target.length > 0) {
      e.preventDefault();

      $('html, body').animate({scrollTop: $target.offset().top}, 250);

      return;
    }
  });
}

function menu() {
  let menu = new SideMenu();

  $(document).on('click', '#primary-navigation .menu-categories', function() {
    menu.toggle();
  });

  PubSub.subscribe('overlay:click', function() {
    menu.close();
  });

  $(document).on('keydown', e => {
    if (menu.isOpen() && e.which == 27) {
      menu.close();
    }
  });

  $('[data-target="#mobile-navigation"]').on('click', function() {
    document.body.classList.toggle('mobile-nav-open');
  });
}

function checkMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
}

function uiOverlayTransition(classBase = 'overlay', show = true)
{
  let action = show ? 'in' : 'out';
  let b = document.body.classList;

  b.add(`${classBase}-${action}-active`);

  setTimeout(() => {
    b.add(`${classBase}-${action}-to`);
  }, 1);

  setTimeout(() => {
    b.remove(`${classBase}-${action}-active`);
    b.remove(`${classBase}-${action}-to`);

    PubSub.publish('transition:end', { base: classBase, show })
  }, 300);
}

function overlay()
{
  let b = document.body.classList;

  PubSub.subscribe('overlay:show', function() {
    uiOverlayTransition('overlay', true);
  });

  PubSub.subscribe('overlay:hide', function() {
    uiOverlayTransition('overlay', false);
  });

  PubSub.subscribe('transition:end', function(name, { base, show }) {
    if (base === 'overlay') {
      if (show === true) {
        b.add('overlay-active');
      } else {
        b.remove('overlay-active');
      }
    }
  });
}

function mobileMenu() {
  let isMobile = checkMobile();

  $(document).on('click', '#mobile-navigation .menu-item a[href="#"], .menu-item-subnav-toggle', function(e) {
    e.preventDefault();

    $(this).parent().find('.sub-menu').stop().slideToggle(150);
  });

  PubSub.subscribe('locations:show', function() {
    $('#mobile-navigation').slideUp();

    document.body.classList.remove('mobile-nav-open');
  });

  PubSub.subscribe('window:resize', function() {
    let current = checkMobile();

    if (isMobile != current) {
      isMobile = current;

      $('.sub-menu').prop('style', false);
    }
  });
}
// setTimeout pointer so we can loop and confirm that our google maps are loaded
function gformFilters()
{
  jQuery(document).on('gform_confirmation_loaded', function(event, formId){
    setTimeout(function() {
      $('html, body').animate({

        scrollTop: $(`#gform_confirmation_message_${formId}`).offset().top - 150,
      }, 300);
    }, 25);

  });
}

function featuredEventHeights()
{
  // Get an array of all element heights
  var elementHeights = $('.event-card__info').map(function() {
    return $(this).height();
  }).get();

  // Math.max takes a variable number of arguments
  // `apply` is equivalent to passing each height as an argument
  var maxHeight = Math.max.apply(null, elementHeights);

  // Set each height to the max height
  $('.event-card__info').height(maxHeight);
}

function preventCloseFilterBar()
{
  $('body').removeClass('tribe-filters-closed').addClass('tribe-filters-open');

  PubSub.subscribe('window:resize', function() {
    $('body').removeClass('tribe-filters-closed').addClass('tribe-filters-open');
  });
}

function preventClosedFilter()
{
  $(".tribe_events_filter_item").removeClass('closed');

  PubSub.subscribe('window:resize', function() {
    $(".tribe_events_filter_item").removeClass('closed');
  });

  $(".tribe-events-filters-group-heading").on('click', function(event){
    event.preventDefault();
    event.stopPropagation();

  });
}

window.headerNavOpen = function() {
  document.body.classList.add('header-nav-open');
};

window.headerNavClose = function() {
  document.body.classList.remove('header-nav-open');
};

function eventCardHeights()
{
  var highestBox = 0;
  
  $('.event-card .event-card__info').each(function(){  
    if($(this).height() > highestBox){  
      highestBox = $(this).height();  
    }
  });
  
  $('.event-card .event-card__info').height(highestBox);
}

export default {
  init() {
    anchorLinks();
    accordions();
    initSliders();
    toggles();
    menu();
    mobileMenu();
    overlay();
    gformFilters();
    featuredEventHeights();
    preventCloseFilterBar();
    preventClosedFilter();
    eventCardHeights();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js